import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import ApiProxy from "@ts/ApiProxy";
import { Product } from "./ProductTypes";
import ReviewOverview from "./ReviewOverview";
import BookmarkCookie from "../shared/BookmarkCookie";

export default class ProductOutline extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);
    
    let reviewOverviewElem: ComponentElem = this.$root.find(`[component="review-overview"]`)[0] as ComponentElem,
    reviewOverview = new ReviewOverview(reviewOverviewElem);
    this.$root.find(".misc > .points").text(reviewOverview.finalRatingString); 

    this._setupBookmark();
  }

  private _setupBookmark()
  { 
    BookmarkCookie.init();
    let pageData = ApiProxy.getPageData() as Product.PageData,
      productId = pageData.id;

    let $bookmark = this.$root.find(".bookmark-tag");

    $bookmark.attr("is-saved", BookmarkCookie.isProductBookmarked(productId)? "true": "false");
    
    $bookmark.on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();

      if(BookmarkCookie.isProductBookmarked(productId))
      {
        BookmarkCookie.delete(productId);
        $bookmark.attr("is-saved", "false");
      }
      else
      {
        let success: boolean = BookmarkCookie.save(productId);
        if(success) $bookmark.attr("is-saved", "true");
      }
      
    });
  }
}